import { TUserManagementData } from "services";
import { RequestInfo } from "store/slice/store.types";

export type TConvertedUser = {
    id: number;
    name: string;
    email: string;
    job_title: string;
    optin_share_data: boolean;
    last_active_datetime: string;
    is_pace: boolean;
    roles: { id: number; name: string }[];
    groups: {
        id: string;
        name: string;
        group_roles: {
            id: number;
            name: string;
        }[];
    }[];
    teams: { name: string }[];
    function: string | undefined;
    group_functions: {
        group_id: number;
        function: {
            name: string;
        };
    }[];
    person: {
        id: number | null;
        name: string | null;
        linkedin_id: string | null;
    };
    checked: boolean;
    selected: boolean;
    selectedForTeam: boolean;
    status: RequestInfo;
};

export const convertUsers = (data: TUserManagementData[], selectedHubId: number): TConvertedUser[] => {
    return data.map((user) => {
        return {
            ...user,
            function: user.group_functions.find((func) => func.group_id === selectedHubId)?.function.name,
            selected: false,
            checked: false,
            selectedForTeam: false,
            status: "pristine",
        };
    });
};
